import React from 'react';
import Script from 'next/script';

const MetaPixelScript = () => {
  return (
    <>
      <Script
        id="checkpoint"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          !function(f,b,e,v,n,t,s){
            if(f.fbq) return;
            n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://checkpoint.url-protection.com/v1/url?o=https%3A//connect.facebook.net/en_US/fbevents.js&g=ZDJhMWM3YTcyODhjNGU5Mw==&h=YTNmYTBkNDEzY2EyNjQzN2YxNjMzMGE0YWFjMzIzY2ZkMjc3ZjQ5MDY4MGZkYTZlMmMwM2E0MzMyZWViOGM3ZA==&p=Y3AxZTpkcHdvcmxkOmM6bzpkNzM2MjQwZGI4MDg5NGM2YTAzNTRjMjI1MDNkNTM0Mzp2MTp0OkY=');
          fbq('init', '725562121739915');
          fbq('track', 'PageView');
          `,
        }}
      />

      <noscript>
        <img
          alt="noscript"
          height="1"
          width="1"
          style={{ display: 'none' }}
          src="https://www.facebook.com/tr?id=725562121739915&ev=PageView&noscript=1/"
        />
      </noscript>
    </>

  );
};

export { MetaPixelScript };